import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-alerta',
  templateUrl: './alerta.component.html',
  styleUrl: './alerta.component.scss'
})

export class AlertaComponent {
  @Input() SYS41ARC : any;

  ngOnInit(): void {
  }
}
